function naturalCompare(a, b) {
    var ax = [], bx = [];

    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });

    while (ax.length && bx.length) {
        var an = ax.shift();
        var bn = bx.shift();
        var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1], 'pt', { sensitivity: 'base' });
        if (nn) return nn;
    }

    return ax.length - bx.length;
}

export function sortList(props: string[] = [], self: boolean = false, isAsc = true) {

    const direction = isAsc == false ? -1 : 1;

    try {
        if (props && props.length > 0 && props[0].length == 0) throw new Error(' ** Por favor, informe uma propriedade válida! **');

        if (self == true) {
            return this.sort((n1, n2) => naturalSortData(n1, n2, props) * direction);
        } else {

            var newArr: Array<any> = new Array();

            if (this.every(it => typeof it === 'string') || this.every(it => typeof it === 'number')) {
                newArr = Object.assign([], this);
            } else {
                newArr = Array.from(this);
            }
            return newArr.sort((n1, n2) => naturalSortData(n1, n2, props) * direction);
        }

    } catch (error) {
        console.error(" --> Falhou em ordenar a lista:", error);
        return this;
    }
}

/**
 * 
 * @param n1 Number or String
 * @param n2 Number or String
 * @param props String[]
 */
export function naturalSortData(n1: number | string, n2: number | string, props: string[]) {

    const hasProperty = props && props.length > 0;

    if (!hasProperty) {
        if (typeof n1 === 'number') return n1 - (n2 as number);
        if (typeof n1 === 'string') return (n1.toLocaleLowerCase() > (n2 as string).toLocaleLowerCase() ? 1 : -1);
        else throw new Error(' ** Só é possivel ordenar listas primitivas de String ou Number, caso esteja tentando ordenar uma lista de objetos, por favor, informe a lista de identificadores de propriedade que deseja utilizar como critério no parâmetro da função **');
    } else {
        /// No momento não haverá ordenações compostas, por isso, utilizaremos o primeiro item da lista
        let result = 0;

        // nosonar
        for (let index = 0; index < props.length; index++) {

            const prop = props[index];

            result = 0;

            var prop1 = getPropValue(prop, n1);
            var prop2 = getPropValue(prop, n2);

            if (typeof prop1 === 'number') {

                result = prop1 - prop2;

                if (result != 0) {
                    break;
                }
            } else {
                result = naturalCompare(prop1.toLocaleLowerCase(), prop2.toLocaleLowerCase());
                if (result != 0) {
                    break;
                }
            }
        }

        return result;
    }
}

function getPropValue(prop: string, n: any) {
    var aux;
    prop.split(".").forEach(item => {
        if (!aux) aux = n[item];
        else aux = aux[item];
    });
    return aux;
}

export { }
if (!Array.prototype.naturalSort) {
    Array.prototype.naturalSort = sortList;
}